export const LAST_KEY = "jayerindo.reminderCenter.shown.v1";
const TZ = "Asia/Jakarta";
export const wibParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {timeZone:TZ, year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",hourCycle:"h23"}).formatToParts(date);
  const get = type => parts.find(x => x.type === type)?.value || "";
  return { day: `${get("year")}-${get("month")}-${get("day")}`, clock: `${get("hour")}:${get("minute")}` };
};
export function isReminderDue(reminder, now, storage) {
  if (!reminder.enabled) return false;
  const key = LAST_KEY + "." + reminder.id;
  if (reminder.kind === "ANNOUNCEMENT") {
    return storage.getItem(key + ".version") !== String(reminder.updated_at || reminder.id);
  }
  if (reminder.schedule_type === "DAILY") {
    const {day,clock} = wibParts(new Date(now));
    if (clock < (reminder.daily_time_wib || "23:59")) return false;
    return storage.getItem(key + ".day") !== day;
  }
  const last = Number(storage.getItem(key) || 0);
  if (!last) return false;
  return now - last >= Math.max(5, Number(reminder.interval_minutes) || 10) * 60000;
}
export function markReminder(reminder, now, storage) {
  const key = LAST_KEY + "." + reminder.id;
  storage.setItem(key,String(now));
  if (reminder.kind === "ANNOUNCEMENT") storage.setItem(key + ".version", String(reminder.updated_at || reminder.id));
  if (reminder.schedule_type === "DAILY") storage.setItem(key + ".day", wibParts(new Date(now)).day);
}
